module.exports = __webpack_public_path__ + "img/shoushi03.ca0e8662.png";